<div class="header">
  <div class="k-container">
    <img class="logo" src="../../../assets/Logotipo-Kumon.png" />
  </div>
</div>
